module.exports = __webpack_public_path__ + "de27297d4bd4952f0ce8c1f66528b27d.png";